import React from 'react';
import { ProtectDemo } from './demos/ProtectDemo';
import { PrepareDemo } from './demos/PrepareDemo';
import { HistoryDemo } from './demos/HistoryDemo';
import { ProfilesDemo } from './demos/ProfilesDemo';
import { ExportDemo } from './demos/ExportDemo';
import type { WhatsNewFeatureId } from '../../data/whatsNew';
const demos: Record<WhatsNewFeatureId, () => React.ReactElement> = {
  protect: ProtectDemo,
  prepare: PrepareDemo,
  history: HistoryDemo,
  profiles: ProfilesDemo,
  export: ExportDemo
};

/** Interactive, working excerpt of the UI for each feature. */
export function FeatureCutout({
  id
}: {
  id: WhatsNewFeatureId;
}) {
  const Demo = demos[id];
  return <Demo data-id="element-1004" data-mp="3u0dczgeekpzx" />;
}